import { createImmutableObjectClass } from 'immutable-less/ImmutableObject';
export default class OutputTypeDefinitionOption extends createImmutableObjectClass({
  label: '',
  value: '',
  displayOrder: 0,
  doubleData: 0,
  hidden: false,
  description: '',
  readOnly: false
}) {
  getLabel() {
    return this.label;
  }
  getValue() {
    return this.value;
  }
  getDescription() {
    return this.description;
  }
  getReadOnly() {
    return this.readOnly;
  }
  getAsSelectOption() {
    return {
      disabled: this.readOnly,
      text: this.label,
      value: this.value,
      help: this.description
    };
  }
}